import { render, staticRenderFns } from "./TerminosPage.vue?vue&type=template&id=2d9e773a&"
import script from "./TerminosPage.vue?vue&type=script&lang=js&"
export * from "./TerminosPage.vue?vue&type=script&lang=js&"
import style0 from "./TerminosPage.vue?vue&type=style&index=0&id=2d9e773a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports